// Input validation for client-side checks only
export const validateInput = (value) => {
  if (typeof value !== 'string') return true;
  
  // Check for potentially dangerous patterns
  const dangerousPatterns = [
    /<script/i,
    /javascript:/i,
    /on\w+\s*=/i
  ];
  
  return !dangerousPatterns.some(pattern => pattern.test(value));
};

export const validateObject = (obj) => {
  if (!obj || typeof obj !== 'object') return { isValid: false };
  
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' && !validateInput(value)) {
      return { isValid: false, field: key };
    }
  }
  return { isValid: true };
};